function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: -0.000488281,
  width: 35.0005,
  height: 35,
  rx: 3,
  fill: "#201D2F"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.1315 19.6625H21.2079C21.2547 19.6625 21.3012 19.656 21.346 19.6433C21.3762 19.6348 21.4042 19.6199 21.4308 19.6032L27.6785 15.6903C27.7051 15.6736 27.7336 15.6601 27.7617 15.646C27.917 15.5678 28.0159 15.4144 28.0159 15.2457V12.7994C28.0159 12.6129 27.8952 12.4468 27.7144 12.3783C27.6901 12.3692 27.6656 12.3604 27.6421 12.3494L21.4074 9.41681C21.3839 9.40575 21.3597 9.39605 21.3343 9.39066C21.301 9.38358 21.2675 9.38 21.2327 9.38H11.1167C4.7739 9.38 3.71677 19.6625 11.1167 19.6625H12.7677C13.0329 19.6625 13.2479 19.8656 13.2479 20.1161V24.3057C13.2479 24.5729 13.4912 24.7822 13.7729 24.7573L18.6961 23.814C18.9429 23.7922 19.1315 23.5965 19.1315 23.3623V19.6625ZM19.1315 19.6625H16.4193M20.2659 16.8197H6.91596M23.8788 18.1406V18.8109C23.8788 19.0253 24.0376 19.2104 24.2595 19.2547L26.4758 19.6978C26.7744 19.7575 27.0555 19.5424 27.0555 19.254V16.1846M23.8788 10.5V9.77022C23.8788 9.54586 24.0524 9.3552 24.2872 9.32167L26.5035 9.00518C26.794 8.96369 27.0555 9.17617 27.0555 9.45372V12.1018M28.496 14.37H31.4168M29.4564 16.1846V12.5555",
  stroke: "#F0F0F5",
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.0164 20.6398C7.95052 18.3773 4.99947 20.1308 3.99947 21.3584L12.3986 27.5568C13.2768 26.2393 14.0824 22.9024 11.0164 20.6398Z",
  stroke: "#F0F0F5"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 7.35381,
  cy: 25.6029,
  r: 0.923444,
  transform: "rotate(36.4265 7.35381 25.6029)",
  stroke: "#F0F0F5"
});

function SvgRov(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRov);
export default __webpack_public_path__ + "static/media/rov.8eb15fdd.svg";
export { ForwardRef as ReactComponent };